import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule} from '@angular/router';
import { TableComponent } from './table.component';
import { TableRoutingModule } from './table-routing.module';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {TableModule} from "../../component/ing/table/table";
import {SharedModule} from "../../component/shared/shared.module";


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TableRoutingModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    TableModule,
    SharedModule,
    RouterModule
  ],
  declarations: [TableComponent]
})
export class TableDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/table/tableDemo.module.ts